import styled from "styled-components";

const Toggle = styled.button`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: none;
  outline: none;
  background: none;
  font-size: ${({ theme }) => theme.fonts.button.fontSize};
  font-family: ${({ theme }) => theme.fonts.button.family};
  font-weight: ${({ theme }) => theme.fonts.button.fontWeight};
  line-height: ${({ theme }) => theme.fonts.button.lineHeight};
  letter-spacing: ${({ theme }) => theme.fonts.button.letterSpacing};
  color: ${({ theme }) => theme.colors.primary1};
  align-items: center;
  gap: 0.5rem;
  padding: 0;
  cursor: pointer;

  img.toggle {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export default Toggle;
